function setCookie(name, value, days) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);
    const cookieValue = encodeURIComponent(value) + (days ? `; expires=${expirationDate.toUTCString()}` : "");
    document.cookie = `${name}=${cookieValue}; path=/`;
}

function getCookie(name) {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + "=")) {
            return cookie.substring(name.length + 1, cookie.length);
        }
    }
    return null;
}

function setThemeMode(dataAttributeValue) {
    document.documentElement.setAttribute("data-bs-theme", dataAttributeValue);
}



const themeMode = getCookie("theme-mode");

if (themeMode === "auto") {
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        setThemeMode("dark");
    } else {
        setThemeMode("light");
    }
} else {
    setThemeMode(themeMode);
}



document.querySelector("body").addEventListener("click", function (event) {
    const target = event.target;
    if (target.classList.contains("theme-option")) {
        const selectedTheme = target.getAttribute("data-theme-value");

        if (selectedTheme === "auto") {
            if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
                document.documentElement.setAttribute("data-bs-theme", "dark");
            } else {
                document.documentElement.setAttribute("data-bs-theme", "light");
            }
        } else {
            document.documentElement.setAttribute("data-bs-theme", selectedTheme);
        }

        document.getElementById("ThemeSelector").textContent = "Theme: " + selectedTheme;

        setCookie("theme-mode", selectedTheme, 365);
    }
});


